import type { Modifier } from '@mattoespresso/brew-firestore';

import { useContext, createContext } from 'react';
import { query, where, collection } from 'firebase/firestore';

import { useCollectionData } from 'src/hooks/useCollectionData';

import { FIRESTORE } from 'src/lib/firebase';
import { COLLECTIONS } from 'src/lib/consts';

const ProductModifiersContext = createContext<{
  data: Modifier[];
  loading: boolean;
  error: any;
}>({
  data: [],
  loading: false,
  error: null,
});

export function useProductModifiers() {
  return useContext(ProductModifiersContext);
}

export function ProductModifiersProvider({ children }: { children: React.ReactNode }) {
  const value = useCollectionData<Modifier>({
    collectionName: COLLECTIONS.item_modifier_group,
    query: query(
      collection(FIRESTORE, COLLECTIONS.item_modifier_group),
      where('deleted', '==', false)
    ),
  });

  return (
    <ProductModifiersContext.Provider value={value}>{children}</ProductModifiersContext.Provider>
  );
}
